import React from "react";
const tabNames = [
  "Overview",
  "Itinerary",
  "TourDates",
  "Inclusions / Exclusions",
  "Tour Information",
  "Cancellation Policy",
  "Documents",
];

const Tabs = ({ activeTab, handleTabClick }) => {
  return (
    <ul className="nav nav-tabs nav-tabs-packmain" id="myTab" role="tablist">
      {tabNames.map((tabName) => (
        <li className="nav-item" role="presentation" key={tabName}>
          <button
            className={`nav-link ${activeTab === tabName ? "active" : ""}`}
            onClick={() => handleTabClick(tabName)}
            type="button"
            role="tab"
            aria-controls={tabName}
            aria-selected={activeTab === tabName}
          >
            {tabName}
          </button>
        </li>
      ))}
    </ul>
  );
};

export default Tabs;
